export const TRANSLATIONS_RU = {
  navBar: {
    link: {
      home: "Главная",
      promo: "Промо-код",
      faq: "FAQ",
    },

    lang: {
      title: "Язык",
      "en-US": "Английский",
      "ru-RU": "Русский",
      "de-DE": "Немецкий",
    },

    btn: "Обмен",
    etention: "Перед отправкой, проверьте правильность Ваших реквизитов получения!"
  },

  home: {

    banner: {
      title: "Хотите получить самый выгодный курс обмена валют?",
      desc: "Рады предложить надежный, выгодный, мгновенный и удобный сервис ввода / вывода электронных валют.",
      btn: "Обменять",
    },

    exchenge: {
      title: {
        main: "Обмен",
        sub: "Валюты",
      },

      give: "Отдаю",
      receive: "Получаю",
      amount: "Количество",
      choose: "Выберете валюту",
      btn: "Обменять",

      agreement: {
        first: 'При нажатии на кнопку "Обменять" Вы соглашаетесь c',
        link: "Пользовательским соглашением",
        second: "нашего ресурса",
      },

      modalError: {
        title: "Ошибка! Пожалуйста, заполните все поля.",
      },

      modalSuccess: {
        title: "Заявка отправлена! Проверьте пожалуйста Вашу почту"
      },

      modalSend: {
        title: "Заполните форму для отправки заявки!",
        form: {
          name: "Введите ваше имя *",
          number: "Введите ваш номер телефона *",
          email: "Введите вашу почту @gmail.com*",
          wallet: "Введите ваш кошелек *",
          promo: "Введите промо-код (Если имеется)",
        },
        error: "Заполните все поля ввода, почта формата @gmail.com",
        success: "Заявка отправлена, ожидайте ответа от менеджера",
        btn: "Отправить запрос",
      },

      feature: {
        course: "Cамый выгодный курс",
        refill: "От 50$. пополнение",
        commission: "0.5% - 1% комиссия",
        support: "Поддержка 24/7",
      },
    },

    advantage: {
      title: {
        small: "Наши преимущества",
        main: "Почему нужно",
        sub: "выбрать нас?",
      },

      safely: {
        title: "Безопасно",
        desc: "С нами Вам не стоит беспокоиться о безопасности Ваших средств",
      },
      bonuses: {
        title: "Бонусы",
        desc: "Ежедневный промокод-скидка на комиссию в размере 1-3%",
      },
      fast: {
        title: "Быстро",
        desc: "Мы обеспечиваем быстрый обмен Ваших средств",
      },
      support: {
        title: "Быстрая поддержка",
        desc: "Наши менеджеры готовы обеспечить Вам профессиональную, быструю поддержку",
      },
    },

    about: {
      title: {
        small: "О компании",
        main: "Выгодный и удобный",
        sub: "сервис",
      },

      desc: {
        first:
          "Конвертер валют предоставляет возможность в режиме онлайн пересчитать нужную сумму из одной валюты в другую.",
        second: "Все пересчеты конвертер выполняет на основе официальных данных.",
        third: "Информация о котировках валют обновляется каждый час.",
        fourth: "Онлайн-конвертер валют очень удобен в использовании и сэкономит ваше время.",
      },
    },
  },

  promo: {
    title: {
      small: "Промокод",
      main: "Ваш промокод на скидку",
    },
    time: "Действует до 22.07.2023",
  },

  faq: {
    title: "Часто задаваемые вопросы",
    faqContent: [
      {
        title: "Как работает обменник?",
        desc: "Обменник полностью автоматический. Вы можете совершать обмены 24/7/365. Выплата осуществляется мгновенно после зачисления Ваших средств на наш кошелек. Информация про статус заявки обновляется на странице оплаты и дублируется на почту.",
      },
      {
        title: "Вы используете AML проверку?",
        desc: 'Да, мы используем AML проверку криптовалюты на наличие рисков с помощью системы наших партнеров "Crystal Blockchain". Данная проверка выявляет криптовалюту, которая была украдена у ее владельцев, получена мошенническим путём, проходила через "миксер" или была задействована в продаже запрещенных товаров на площадках Darknet. В случае выявления такой криптовалюты нашей системой, Ваша заявка получает статус "Рискованная оплата".',
      },
      {
        title: "Какие сроки зачисления средств?",
        desc: "Выплата осуществляется мгновенно после зачисления Ваших средств на наш кошелек.Если заявка находится в статусе «Выполнена», значит средства списаны с нашего счета и отправлены на указанные Вами реквизиты.",
      },
      {
        title: "Возможно ли мне отменить заявку?",
        desc: "Вы можете отменить заявку, написав в чат техподдержки на сайте. При этом возврат будет осуществлен с комиссией сервиса 10% и после зачисления Ваших средств на наш кошелек. Выполненную заявку отменить нельзя.",
      },
      {
        title: "Вы фиксируете курс обмена?",
        desc: "Да, курс фиксируется на 90 минут для Биткоина и на 30 минут для остальных криптовалют. После этого времени заявка остается действующей и будет выполнена согласно условиям обмена.",
      },
      {
        title: "Что будет с заявкой, когда время фиксации курса пройдёт?",
        desc: "Заявка останется действующей и будет автоматически выполнена по факту получения подтверждений в блокчейне. В случае, если курс упадет, Вам на почту прийдёт сообщение с информацией для самостоятельного выполнения пересчета заявки по актуальному курсу или оформления возврата. Если Вами не будет принято решение в течении 12 часов, то заявка будет пересчитана автоматически по актуальному курсу. Если курс вырастет, то заявка будет выполнена автоматически по курсу на момент её создания.",
      },
      {
        title: "Какие бывают статусы заявок?",
        desc: 'Статусы меняются по ходу выполнения обмена и доступны на странице оплаты. Также статусы дублируются на почту. "Ожидает оплаты" - заявка создана, но средства на наш кошелек еще не зачислены. "Ожидает подтверждений" - транзакция попала в блокчейн и ожидает подтверждений от майнеров в сети. "Выполнена" - средства отправлены на указанные Вами реквизиты, ожидайте зачисление, согласно регламента. "Закрыта" - оплата по заявке нами не получена, заявка закрыта по истечению времени. Если оплата поступит, заявка будет выполнена. "Оплачена. Курс изменился" - время фиксации курса прошло и он снизился. Вам нужно сделать пересчёт или оформить возврат. "Рискованная оплата" - Ваша криптовалюта ранее была использована на запрещенных площадках Даркнета или пропущена через "Миксер". Пожалуйста, оформите возврат. "Неверная сумма оплаты" - Вы оплатили меньше минимальной суммы к обмену. Пожалуйста, оформите возврат. "Выплата отклонена" - нам не удалось отправить средства на указанные реквизиты, возможно из-за лимитов. Вы можете самостоятельно повторить выплату или сменить номер карты в личном кабинете или через ссылку, отправленную на почту. "Выплачена частично" - нам не удалось отправить часть средств на указанные реквизиты, возможно из-за лимитов. Вы можете самостоятельно повторить выплату или сменить номер карты в личном кабинете или через ссылку, отправленную на почту.',
      },
      {
        title: '"Ожидает подтверждения" - что это и кто должен подтвердить?',
        desc: "Перевод криптовалюты считается выполненным, когда он получает необходимое количество подтверждений в сети блокчейн. После 2х подтверждений для Биткоина и 6ти для Эфириума и других криптовалют будет произведена автоматическая выплата. На скорость получения подтверждений влияет выставленная Вами комиссия за перевод и загрузка сети. Так как отменить транзакцию и повлиять на ее скорость уже нельзя, остается только ждать подтверждения.",
      },
      {
        title: "Я оплатил меньше, чем указал в заявке.",
        desc: "Не проблема. После подтверждений в блокчейн будет выполнен автоматический пересчет на полученную нами сумму с учётом разницы курса, если он упадёт.",
      },
      {
        title: '"Рискованная оплата" - что это и что делать?',
        desc: 'Все биржи, а также некоторые ресурсы, используют проверку криптовалюты на наличие рисков. Мы используем топовую систему "Crystal Blockchain". Статус "Рискованная оплата" означает, что большая часть криптовалюты, которую Вы нам отправили, ранее была задействована при продаже запрещенных товаров на маркетплейсах Даркнета, пропущена через "Миксер" с целью отмывания средств или же была украдена. Если заявка попала в этот статус, Вам необходимо самостоятельно оформить возврат на странице оплаты или через ссылку в письме на почте.',
      },
      {
        title: "Я оплатил, а заявка закрылась.",
        desc: 'В первую очередь проверьте списание валюты со своего кошелька. Так же имейте ввиду, что некоторые ресурсы хранения криптовалюты выполняют отправку с задержкой. В данном случае статус заявки "Закрыта" временный и она будет выполнена после зачисления валюты на наш кошелек.',
      },
      {
        title: "Какая комиссия за возврат?",
        desc: 'Комиссия за возврат криптовалюты составляет 10 USDT, 0.003 ETH, 0.0003 BTC.В случае "Рискованной оплаты", возврат осуществляется за вычетом актуальной комиссии в блокчейн.При отмене заявки по инициативе клиента, возврат будет осуществлен с комиссией сервиса 10% и после зачисления Ваших средств на наш кошелек.Возврат криптовалюты, с которой наш сервис не работает, или монет, ошибочно отправленных не в той сети, производится за вычетом 10% от суммы обмена.',
      },
      {
        title: "Я ошибся сетью/криптовалютой при оплате заявки.",
        desc: "Наши специалисты рассмотрят конкретный случай и в течении суток сообщат про возможность возврата такой криптовалюты. В случае наличия технической возможности, возврат будет сделан в течении 10 дней за вычетом 10% от суммы заявки.",
      },
    ],
  },

  copy: {
    copy: "Скопировать",
    success: "Скопировано",
  },

  policy: {
    title: {
      main: "Политика",
      sub: "конфиденциальности",
    },
    policyContent: [
      {
        number: "1",
        title: "Основное",
        desc: [
          {
            title:
              "1.1. Пожалуйста, прочтите следующие положения относительно услуг хранения информации, предоставляемых Obmen-House. Obmen-House оставляет за собой право изменить Положения о конфиденциальности в любое время без предварительного уведомления. Только онлайн положения о конфиденциальности действительны, так что периодически читайте Положение о конфиденциальности на сайте. Данные положения были разработаны нашей командой с целью показать заботу сервиса Obmen-House о сохранности информации своих клиентов. Мы хотим показать, что хранение информации с помощью https://obmen-house.io является абсолютно безопасным. Ниже Вы можете ознакомиться с положениями о конфиденциальности.",
          },
          {
            title:
              "1.2. Сервис Obmen-House получает персональные данные от Пользователя при регистрации либо при оформлении Заявки и фиксирует их в базе-данных.",
          },
          {
            title:
              "1.3. Сервис использует файлы cookies, данные о IP-адресе пользователя, сведения о браузере пользователя, для работы программно-технических средств Веб-сайта.",
          },
          {
            title: "1.4. Obmen-House в праве запросить дополнительную информацию о персональных данных пользователя.",
          },
          {
            title:
              "1.5. Персональные данные пользователя могут быть использованы сервисом исключительно в целях обеспечения работы Сервиса и не могут быть переданы третьим лицам за исключением случаев, предусмотренных законодательством, правилами работы обменных пунктов для конкретной ЭПС и нормами международного права.",
          },
        ],
      },
      {
        number: "2",
        title: "Личные данные пользователей",
        desc: [
          {
            title:
              "2.1. При регистрации пользователи оставляют некоторую информацию, а именно: логин, пароль, имя, контактную информацию, например, адрес электронной почты. Эта информация используется для обеспечения работы служб Obmen-House. Информация о регистрации (логин, пароль) - для аутентификации пользователей, контактная информация (имя, адрес электронной почты), используется для предоставления информации пользователям о новых возможностях системы. Мы не предоставляем контактную информацию третьим лицам без Вашего согласия.",
          },
          {
            title:
              "2.2. Obmen-House соблюдает законы - в редких случаях, при соблюдении всех правовых норм, информация пользователя может быть передана в правоохранительные органы. Obmen-House может также собирать и анализировать определенную информацию посетителей и пользователей касающейся использования услуг Obmen-House. Собранная информация может включать объем трафика, частоту посещений, тип и время операции, тип браузера и операционной системы, и т.д. Эта информация записывается, чтобы помочь диагностировать технические проблемы, администрировать сайт, а также улучшить качество и виды предоставляемых услуг.",
          },
        ],
      },
      {
        number: "3",
        title: "Файлы cookie",
        desc: [
          {
            title:
              "3.1. Obmen-House использует временные и постоянные файлы cookie. Временные cookie будут удаляться из компьютера каждый раз, когда Вы закрываете Ваш браузер.",
          },
          {
            title:
              "3.2. Выбирая «Запомнить меня» в сервисе Obmen-House, вы сохраните логин и пароль на своем компьютере, а это означает, что при возвращении на сайт Вам не придётся вводить их заново. Если у Вас отключены cookie, Вам не будут доступны некоторые разделы веб-сайта.",
          },
        ],
      },
      {
        number: "4",
        title: "Сайты третьих лиц",
        desc: [
          {
            title:
              "4.1. Наш сайт содержит ссылки на другие сайты в Интернете, которые имеют иную от Obmen-House политику конфиденциальности. Obmen-House не предоставляет каких-либо гарантий в отношении политики безопасности сайтов, на которые ссылается сервис Obmen-House или их пользователей.",
          },
          {
            title:
              "4.2. Мы рекомендуем Вам ознакомиться с положениями политики приватности, доступной на этих сайтах, для более глубокого понимания своих прав.",
          },
          {
            title:
              "4.3. Obmen-House никогда не будет продавать или передавать Вашу личную информацию третьим лицам в маркетинговых или каких-либо других целях без Вашего разрешения.",
          },
        ],
      },
      {
        number: "5",
        title: "Безопасность",
        desc: [
          {
            title:
              "5.1. Наши специалисты разрабатывают современные системы безопасности для обеспечения надежной защиты информации пользователей. Каждый пользователь при регистрации получает логин и пароль.",
          },
          {
            title:
              "5.2. В интересах пользователей не сообщать третьим лицам свой пароль и логин. Данные меры помогут предотвратить несанкционированный доступ и обеспечить надлежащее использование данных.",
          },
        ],
      },
    ],
  },

  terms: {
    title: {
      main: "Пользовательское",
      sub: "соглашение",
    },
    termsContent: [
      {
        number: "1",
        title: "Термины и определения",
        desc: [
          {
            title:
              "1.1. Obmen-House — это автоматизированный веб-сервис, расположенный в сети Интернет по адресу https://obmen-house.io и предлагающий свои услуги с помощью специального программного интерфейса для всех Пользователей (далее по тексту — Сервис).",
          },
          {
            title:
              "1.2. Пользователь — это любое физическое или юридическое лицо, согласившееся со всеми условиями, предложенными Сервисом, и присоединившееся к данному соглашению.",
          },
          {
            title:
              "1.3. Электронные единицы (титульные знаки) — учетные единицы соответствующих систем электронных расчетов, обозначающие определенный объем прав требования или иных прав, вытекающих из договора систем электронных расчетов со своими пользователями.",
          },
          {
            title:
              "1.4. Система электронных расчетов (платежная система) — программно-аппаратный продукт, разработанный третьей стороной ипредставляющий собой систему реализации учета электронных единиц, а также организации взаиморасчетов между своими пользователями.",
          },
          {
            title: "1.5. Платеж — перевод электронных единиц от плательщика к получателю.",
          },
          {
            title:
              "1.6. Заявка — информация, поданная Пользователем с использованием средств Сервиса в электронном виде, свидетельствующая о его намерениях воспользоваться услугами Сервиса на условиях,предложенных Сервисом и указанных в параметрах заявки.",
          },
        ],
      },
      {
        number: "2",
        title: "Общие положения",
        desc: [
          {
            title:
              "2.1. Данное соглашение регламентирует отношения между Пользователеми Сервисом по поводу услуг, предоставляемых Сервисом Пользователю и отменяет все предшествующие договоренности между Сервисом и Пользователем по данному предмету.",
          },
          {
            title:
              "2.2. Данное соглашение не отменяет действующего законодательства стран регистрации и местонахождения Пользователя, а также договорных отношений между Пользователем и Системой (системами) электронных расчетов.",
          },
          {
            title:
              "2.3. Данное соглашение считается принятым на условиях публичной оферты, акцептуемой Пользователем в ходе подачи им Заявки,являющейся неотъемлемой частью настоящего соглашения.",
          },
          {
            title: "2.3.1. Публичной офертой признается отображаемая Сервисом информация о параметрах и условиях Заявки.",
          },
          {
            title:
              "2.3.2. Акцептом публичной оферты признается совершение Пользователем действий по завершению формирования Заявки, подтверждающих его намерение совершить сделку с Сервисом на условиях, предложенных Сервисом непосредственно перед завершением формирования Заявки.",
          },
          {
            title:
              "2.3.3. Дата и время акцепта, а также параметры условий Заявки фиксируются Сервисом автоматически в момент завершения формирования Заявки.",
          },
          {
            title:
              "2.3.4. Период принятия предложения Пользователем совершить сделку с Сервисом на условиях, описанных в Заявке Пользователя, составляет 30 минут с момента завершения формирования Заявки.",
          },
          {
            title: "2.4. Данное соглашение вступает в действие с момента завершения формирования Заявки Пользователем.",
          },
          {
            title:
              "2.5. Данное соглашение прекращает свое действие с момента поступления на реквизиты, предоставленные Пользователем, Электронных единиц в сумме, предусмотренной параметрами Заявки Пользователя, либо с момента аннулирования заявки.",
          },
          {
            title:
              "2.6. Стороны признают настоящее соглашение в электронной форме равнозначным по юридической силе договору, заключенному в письменной форме.",
          },
          {
            title:
              "2.7. Сервис оставляет за собой право в одностороннем порядке вносить изменения в систему скидок а также в систему партнерского вознаграждения без соответствующего уведомления об этом Пользователя, но с обязательной публикацией актуальной версии системы отчислений на странице «Справка» разделы «Бонус на обмен» и «Партнерская программа».",
          },
          {
            title:
              "2.8. Сервис оставляет за собой право в одностороннем порядке вносить изменения в данное соглашение без соответствующего уведомления об этом Пользователя, но с обязательной публикацией актуальной версии соглашения на данной странице.",
          },
        ],
      },
      {
        number: "3",
        title: "Предмет соглашения",
        desc: [
          {
            title:
              "3.1. С использованием технических средств Сервиса путем подачи Заявки Пользователь поручает, а Сервис от своего имени и за счет Пользователя совершает за вознаграждение действия по приему идальнейшей передаче заявленной Пользователем суммы Электронных единиц лицу или лицам, желающим приобрести таковые за денежный эквивалент в сумме не ниже, чем предусмотрено в параметрах Заявки, поданной Пользователем, а также действия по передаче денежного эквивалента в сумме, указанной в параметрах заявки, на реквизиты, указанные Пользователем.",
          },
          {
            title:
              "3.2. Любая положительная разница, возникшая в результате действий,описанных в пункте 3.1 настоящего соглашения, как дополнительно полученная выгода, передается в пользу Сервиса в качестве премиальной оплаты комиссионных услуг.",
          },
        ],
      },
      {
        number: "4",
        title: "Условия предоставления услуг",
        desc: [
          {
            title:
              "4.1. Обработка Заявок Пользователя осуществляется Сервисом в строгом соответствии с политикой приватности (пункт 5 настоящего соглашения), а также политикой по противодействию отмыванию денег и предотвращению операций, носящих незаконный характер (пункт 6 настоящего соглашения).",
          },
          {
            title:
              "4.2. Заказ услуг Сервиса, управление процессом сделки и получение информации о ходе выполнения сделки Пользователем производятся исключительно при помощи соответствующего пользовательского интерфейса, предоставляемого Сервисом.",
          },
          {
            title:
              "4.3. Учет операций с электронными единицами производится Сервисом согласно регламенту, правилам и формату соответствующих Системэлектронных расчетов.",
          },
          {
            title:
              "4.4. Любая завершенная операция, проведенная Сервисом по Заявке Пользователя, считается неотменяемой, т.е. не может быть отменена Пользователем после ее завершения — получения Пользователем причитающегося ему по ранее акцептованным условиям сделки.",
          },
          {
            title:
              "4.5. В случае непоступления от Пользователя электронных единиц втечение 15 минут с момента акцепта Пользователя на реквизиты,предоставленные Сервисом, соглашение на условиях, указанных в Заявке, считается расторгнутым Сервисом в одностороннем порядке как не вступившее в действие, без уведомления об этом Пользователя.",
          },
          {
            title:
              "4.5.1. В случае расторжения соглашения Электронные единицы, поступившие после указанного выше срока, подлежат возврату на реквизиты отправителя в течение последующих 24 часов. При осуществлении возврата все комиссионные расходы на перевод электронных единиц производятся из поступивших средств за счет Пользователя. Сервис не несет ответственность за возможные задержки при возврате, если они возникли не по вине Сервиса.",
          },
          {
            title:
              "4.6. В случае, если количество поступивших Электронных единиц отличается от заявленного Пользователем, Сервис может в одностороннем порядке расторгнуть соглашение путем отказа от исполнения заявки и возврата поступивших средств на реквизиты отправителя в течение последующих 24 часов. При осуществлении возврата все комиссионные расходы на перевод Электронных единиц производятся из поступивших средств за счет Пользователя. Сервис не несет ответственность за возможные задержки при возврате, если они возникли не по вине Сервиса.",
          },
          {
            title:
              "4.7. В случае не отправки денежного эквивалента на указанные Пользователем реквизиты в течение 24 часов с момента начала действия договора, при отсутствии причин для блокировки Электронных единиц,поступивших по Заявке Пользователя со стороны Сервиса, Пользователь может потребовать расторжения соглашения путем аннулирования своей заявки и возврата электронных единиц в полном объеме.",
          },
          {
            title:
              "4.7.1. Требование об аннулировании заявки должно быть исполнено Сервисом только в том случае, если на момент получения такого требования денежный эквивалент не был отправлен на реквизиты, указанные Пользователем.",
          },
          {
            title:
              "4.7.2. В случае аннулирования заявки возврат Электронных единиц производится Сервисом на реквизиты отправителя в течение 24 часов с момента получения требования об аннулировании. Сервис не несет ответственность за возможные задержки при возврате, если они возникли не по вине Сервиса.",
          },
          {
            title: "4.8. Сервис имеет право привлекать для исполнения своих обязательств сторонних исполнителей.",
          },
          {
            title:
              "4.9. Сервис имеет право отменить выполняющуюся операцию и вернуть внесенные Пользователем Электронные единицы и/или финансовые средства c возмещением комиссий Систем электронных расчетов Пользователю без объяснения причин.",
          },
          {
            title:
              "4.10. Сервис имеет право отказать Пользователю в дальнейшем обслуживании в случае нарушения Пользователем любого из пунктов настоящего соглашения.",
          },
          {
            title:
              "4.10.1. В случае отказа Сервисом от дальнейшего обслуживания Пользователя, Сервис уведомляет Пользователя о своем решении при помощи электронной почты или телефонного звонка, после чего замораживает аккаунт Пользователя и все текущие Заявки Пользователя. Далее, Сервис осуществляет возврат Электронных единиц, поступивших по Заявке Пользователя на реквизиты отправителя в течение 24 часов с момента отказа. При осуществлении возврата все комиссионные расходы на перевод Электронных единиц производятся из поступивших средств засчет Пользователя. Сервис не несет ответственность за возможные задержки при возврате, если они возникли не по вине Сервиса.",
          },
          {
            title:
              "4.10.2. Все последующие Заявки, созданные Пользователем после отказа Сервисом в дальнейшем обслуживании Пользователя, автоматически замораживаются. Связанные с данными Заявками аккаунты блокируются.",
          },
        ],
      },
      {
        number: "5",
        title: "Политика конфиденциальности",
        desc: [
          {
            title:
              "5.1. Для проведения операций Сервис принимает от Пользователя его персональные данные, которые Сервис обязуется хранить в зашифрованном виде, не придавать огласке, не передавать третьим лицам, за исключением случаев, описанных в п. 5.4, 5.5 и 6.5 настоящего соглашения.",
          },
          {
            title:
              "5.2. Проведение всех операций с Заявками, а также передача персональных данных от Пользователя к Сервису осуществляется по зашифрованному SSL-каналу с длиной ключа 256 бит.",
          },
          {
            title:
              "5.3. Сервис имеет право при необходимости самостоятельно осуществлять деятельность по сбору дополнительных данных о Пользователе любыми доступными способами. Вся информация, собраннаяв результате такой деятельности не придается огласке, не передается третьим лицам, за исключением случаев, описанных в п. 5.4, 5.5 и 6.5 настоящего соглашения.",
          },
          {
            title:
              "5.4. Сервис имеет право передавать персональные данные Пользователяи детали совершенных им операций при условии сохранения их конфиденциального статуса по официальному письменному запросу /решению суда / собственной инициативе (в случае возникновения потребности в проведении расследования) правоохранительным органам,а также Пользователю, которому они принадлежат.",
          },
          {
            title:
              "5.5. Сервис имеет право передавать детали операции и относящиеся коперации персональные данные Пользователя по официальному запросу Системы электронных расчетов для проведения внутренних расследований.",
          },
          {
            title:
              "5.6. Все собранные данные о Пользователе, а также детали совершенных им операций хранятся в базе данных Сервиса в течение пяти лет с момента выполнения Сервисом последней Заявки Пользователя.",
          },
        ],
      },
      {
        number: "6",
        title: "Политика противодействия отмыванию денег и незаконным операциям",
        desc: [
          {
            title:
              "6.1. В соответствии с международным законодательством Obmen-House придерживается ряда правил и реализует ряд процедур, направленных на предотвращение использования Сервиса с целью проведения операций поотмыванию денег, то есть действий, нацеленных на возвращение на финансово-экономический рынок денег или иных ценных бумаг незаконного происхождения, представляя их приобретение и владениеими вполне законными и нормальными, а также проведению иных операций, носящих незаконный характер.",
          },
          {
            title:
              "6.2. Для предотвращения операций незаконного характера Сервис устанавливает определенные требования ко всем Заявкам, создаваемым Пользователем:",
          },
          {
            title:
              "6.2.1. Отправителем и получателем Платежа по Заявке должно быть однои то же лицо. С использованием услуг Сервиса категорически запрещены переводы в пользу третьих лиц.",
          },
          {
            title:
              "6.2.2. Все контактные данные, заносимые Пользователем в Заявку, а также иные персональные данные, передаваемые Пользователем Сервису, должны быть актуальными и полностью достоверными.",
          },
          {
            title:
              "6.2.3. Категорически запрещено создание Заявок Пользователем с использованием анонимных прокси-серверов или каких-либо других анонимных подключений к Интернет.",
          },
          {
            title: "6.3. Для предотвращения операций незаконного характера, Сервис:",
          },
          {
            title:
              "— Использует внутреннюю систему автоматизированного анализатранзакций и поведения Пользователя (систему предотвращения мошенничества), останавливающую все подозрительные транзакции Пользователя.",
          },
          {
            title: "— Придерживается политики «Знай своего клиента».",
          },
          {
            title: "— Осуществляет проверку всеми доступными способами всех данных,предоставляемых Пользователем.",
          },
          {
            title:
              "6.4. Сервис оставляет за собой право заморозить аккаунт Пользователяи все текущие Заявки Пользователя до момента получения от Пользователя копий документов, удостоверяющих личность Пользователя,а также источник происхождения Электронных единиц и другую информацию, необходимую для проверки производимой операции вследующих случаях:",
          },
          {
            title: "— При выявлении нарушения любого из требований, представленных в пункте 6.2 настоящего Соглашения.",
          },
          {
            title: "— При остановке Заявки Пользователя системой предотвращения мошенничества.",
          },
          {
            title:
              "— При возникновении обоснованных подозрений у администрации Сервиса в том, что пользователь пытается воспользоваться услугами Сервиса для отмывания денег или с целью проведения любых других незаконных операций.",
          },
          {
            title:
              "— В свою очередь, Пользователь обязуется предоставить запрашиваемый документ в течение 7 рабочих дней с получения запроса на его предоставление, либо запросить аннулирование заявки.",
          },
          {
            title:
              "6.4.1. В случае отказа Пользователя предоставить запрашиваемые документы Сервис оставляет за собой право отказать Пользователю в дальнейшем обслуживании и предпринять действия, описанные в п. 4.10 настоящего соглашения.",
          },
          {
            title:
              "6.5. Сервис оставляет за собой право отказать Пользователю в дальнейшем обслуживании и предпринять действия, описанные в п. 4.10 настоящего соглашения, после чего передать все имеющиеся у Сервиса данные Пользователя, а также всю имеющуюся информацию об операциях Пользователя в правоохранительные органы в случаях:",
          },
          {
            title:
              "— Выявления транзакций, целью которых является отмывание денег,финансирование террористических организаций, мошенничество любого рода, а также транзакций, направленных на проведение любых других незаконных и неправомерных операций.",
          },
          {
            title:
              "— Возникновении обоснованного подозрения у Сервиса в том, что предоставленный Пользователем документ для идентификации личности Пользователя является поддельным или не действительным.",
          },
          {
            title:
              "— Поступления информации от уполномоченных на то органов о неправомочности владения Пользователем электронными единицами или финансовыми средствами и/или иная информация, делающая невозможным предоставление Сервисом услуг Пользователю.",
          },
          {
            title:
              "— Выявления любых действий или попытки совершения действий Пользователем, направленных на оказание любого негативного влиянияна программно-аппаратный комплекс Сервиса.",
          },
          {
            title:
              "— Выявления любых действий или попытки совершения действий Пользователем, направленных на хищение баз данных и другого материального и нематериального имущества Сервиса.",
          },
          {
            title:
              "— Выявления любых действий или попытки совершения действий Пользователем, способных нанести любой физический, материальный и не материальный вред Сервису.",
          },
          {
            title:
              "6.6. Сервис оставляет за собой право проверять всеми доступными ему способами персональную и любую другую информацию, полученную от Пользователя.",
          },
        ],
      },
      {
        number: "7",
        title: "Ограничение ответственности",
        desc: [
          {
            title:
              "7.1. Сервис предлагает свои услуги круглосуточно и без выходных и будет стремиться к тому, чтобы программно-аппаратный комплекс,реализующий возможности Сервиса, работал без сбоев.",
          },
          {
            title:
              "7.2. Сервис предоставляет свои услуги на условиях «как есть», как они описаны на страницах сайта Сервиса и не предлагает никаких дополнительных гарантий.",
          },
          {
            title:
              "7.3. Используя Сервис, Пользователь соглашается с тем, что объем ответственности Сервиса ограничивается средствами, полученными от Пользователя для исполнения предмета настоящего соглашения, что Сервис не обеспечивает дополнительных гарантий и не несет никакой дополнительной ответственности перед Пользователем, также как и Пользователь не несет дополнительной ответственности перед Сервисом,за исключением случаев, указанных в п. 7.9.",
          },
          {
            title:
              "7.4. Сервис приложит все усилия, но не гарантирует, что его услуги будут доступны круглосуточно и ежедневно. Сервис не несет никакой ответственности за убытки, не полученную прибыль и иные издержки Пользователя, возникшие в результате невозможности получения доступак сайту и услугам Сервиса.",
          },
          {
            title:
              "7.5. Сервис не несет никакой ответственности за убытки, неполученную прибыль и иные издержки Пользователя, явившиеся результатом задержек, ошибок или сбоев в проведении банковских платежей или электронных переводов.",
          },
          {
            title:
              "7.6. Сервис не несет никакой ответственности за убытки, неполученную прибыль и иные издержки Пользователя, явившиеся результатом ошибочных ожиданий Пользователя в отношении тарифных ставок Сервиса,прибыльности транзакций и иных субъективных факторов.",
          },
          {
            title:
              "7.7. В случае предоставления Пользователем ошибочных данных винформации о реквизитах получателя денежных средств Сервис не несетникакой ответственности за любые неблагоприятные последствия или ущерб, возникшие в результате этой ошибки.",
          },
          {
            title:
              "7.8. Пользуясь услугами Сервиса, Пользователь самостоятельно несет ответственность за выплату налогов в соответствии с налоговым законодательством страны по месту его проживания. Сервис не является налоговым агентом и не будет уведомлять Пользователя о каких-либо возможных налоговых издержках при использовании услуг Сервиса.",
          },
          {
            title:
              "7.9. Пользователь гарантирует возмещение убытков Сервиса(управляющей компании, руководителей и сотрудников) в случаях предъявления исков или претензий, прямо или косвенно связанных с использованием Пользователем услуг Сервиса, за исключением убытков,вызванных виновными (умышленными или неосторожными) действиями самого Сервиса.",
          },
          {
            title:
              "7.10. Пользователь гарантирует, что является владельцем или имеет правомочные основания для распоряжения суммами, использующимися в его транзакциях.",
          },
          {
            title:
              "7.11. Пользователь обязуется воздержаться от использования услуг Сервиса для проведения мошеннических и незаконных операций исоглашается с тем, что любая попытка обмена мошеннического капитала будет иметь судебное преследование по всей строгости закона. Действия Пользователя могут считаться незаконными в соответствии с законодательством страны пребывания Пользователя.",
          },
          {
            title:
              "7.12. Пользователь обязуется не фальсифицировать коммуникационные потоки, связанные с функционированием Сервиса, не вмешиваться в его программную и/или аппаратную часть, а также не оказывать какого-либо иного влияния, способного нарушить нормальную работу Сервиса,понимая, что подобные действия будут иметь судебное преследование повсей строгости закона.",
          },
          {
            title:
              "7.13. Пользователь признает, что содержимое сайта Сервиса попадает под защиту законодательства об охране прав собственности,интеллектуальной собственности и авторских прав. Несанкционированное использование этого содержимого незаконно.",
          },
          {
            title:
              "7.14. Ни Пользователь, ни Сервис не будут ответственны друг перед другом за задержки или неисполнение своих обязательств, являющихся результатом возникновения обстоятельств непреодолимой силы, включая стихийные бедствия, пожар, наводнение, террористические акты, смены власти, гражданские волнения, а также нефункционирования Электронных расчетных систем, систем энергоснабжения, сетей связи и поставщиков Интернет-услуг.",
          },
          {
            title:
              "7.15. Электронные расчетные системы и/или финансовые учреждения несут исключительную ответственность за средства, вверенные им Пользователем. Сервис не может являться стороной в соглашении между Платежной системой и/или финансовым учреждением и Пользователем и ни в какой мере не несет ответственности за неправильное или неправомочное использование возможностей Электронной расчетной системы Пользователем, а также за злоупотребление Пользователем функциональностью Электронной расчетной системы. Взаимные права и обязанности Пользователя и Электронной расчетной системы и/или финансового учреждения регулируются соответствующими договорами.",
          },
        ],
      },
      {
        number: "8",
        title: "Порядок принятия претензий и разрешения споров",
        desc: [
          {
            title:
              "8.1. Споры и разногласия, возникшие в рамках предоставления услуг Сервисом Пользователю, разрешаются путем переговоров Пользователя с администрацией Сервиса, на основе положений настоящего соглашения.",
          },
          {
            title:
              "8.1.1. Любые претензии по настоящему соглашению могут быть приняты Сервисом в электронном виде путем отправки сообщения по сути претензии на реквизиты (страница контакты), указанные на сайте Сервиса.",
          },
          {
            title:
              "8.2. В случае невозможности разрешения возникающих вопросов путем переговоров, спор разрешается в соответствии с действующим законодательством по месту регистрации Сервиса.",
          },
        ],
      },
    ],
  },

  footer: {
    desc: "Выгодный и удобный сервис который предоставляет возможность в режиме онлайн пересчитать нужную сумму из одной валюты в другую.",
    btn: "Обменять",
    link: {
      title: "Полезные ссылки",
      promo: "Промо-код",
      faq: "FAQ",
      terms: "Пользовательское соглашение",
      privacy: "Политика конфиденциальности",
    },
  },
};
